import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  sendResetPasswordRequest,
  resetPasswordConfirm
} from "@/services/passwordReset";

@Module({
  namespaced: true
})
export default class Auth extends VuexModule {
  email = "";
  refId = "";
  userType = "";

  get getInfoGatter() {
    return {
      email: this.email,
      refId: this.refId,
      userType: this.userType
    };
  }

  @Mutation
  public setInfo({ email, refId, userType }) {
    if (email) this.email = email;
    if (refId) this.refId = refId;
    if (userType) this.userType = userType;
  }

  @Action
  public async sendPasswordResetEmail(userData: any) {
    try {
      const data = await sendResetPasswordRequest(
        { email: userData.email },
        userData.userType
      );

      this.context.commit("setInfo", {
        refId: data.response.resetRef,
        email: userData.email,
        userType: userData.userType
      });
      return {
        success: true,
        type: "success",
        title: "Success",
        text: data.response.message
      };
    } catch (err) {
      return {
        type: "error",
        title: "Error!!",
        text: err.message
      };
    }
  }

  @Action
  public async resetPassword(payload) {
    try {
      const data = await resetPasswordConfirm(
        { resetRef: this.refId, ...payload },
        this.userType
      );
      return {
        success: true,
        type: "success",
        title: "Success",
        text: data.response.message
      };
    } catch (err) {
      return {
        type: "error",
        title: "Error!!",
        text: err.message
      };
    }
  }
}
